export const findApplicableTypes = ({ enumValues, context }) => {
    if (!Object.values(enumValues).every((it) => it.applicableTypes)) {
        return enumValues;
    }

    const filter = Object.entries(enumValues).filter(([, value]) => value.applicableTypes?.includes(context));
    return Object.fromEntries(filter);
};
